import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postStreamItem } from '../../../api/items';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import { mergeItemWithUserData } from '../../../utils/items';

import { POST_STREAM_ITEM_METHODS } from '../../../components/Items/constants/postStreamItemMethods';
import { REQUEST } from '../../../constants/request';

export const changeItemPrivacy = createAsyncThunk(
  'items/changeItemPrivacy',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [itemResponse, itemUserDataResponse] = await postStreamItem(
        {
          path,
          params: {
            ...params,
            method: POST_STREAM_ITEM_METHODS.public,
          },
        },
        {
          cancelToken: source.token,
        },
      );

      return mergeItemWithUserData(itemResponse, itemUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const itemsStore = getState().items;

      return (
        itemsStore.items.item.actions.update.request[generateItemCIDKey(path)]
          ?.loading !== REQUEST.pending
      );
    },
  },
);

export const changeItemPrivacyExtraReducer = builder => {
  builder.addCase(changeItemPrivacy.pending, (state, action) => {
    const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

    checkAndSetLoadingWithId(
      state.items.item.actions.update.request,
      action,
      itemCIDKey,
    );
  });
  builder.addCase(changeItemPrivacy.fulfilled, (state, action) => {
    const { payload } = action;
    const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

    onMatchedRequest(
      state.items.item.actions.update.request[itemCIDKey],
      action,
      () => {
        state.items.item.byId[itemCIDKey] = payload;
        if (!state.items.item.allIds.includes(itemCIDKey)) {
          state.items.item.allIds.push(itemCIDKey);
        }
      },
    );
  });
  builder.addCase(changeItemPrivacy.rejected, (state, action) => {
    const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

    handleRequestRejection(
      state.items.item.actions.update.request[itemCIDKey],
      action,
    );
  });
};
